export const types = {
  GET_FILE: 'GET_FILE',
  GET_RESOURCES_FOR_LESSON: 'GET_RESOURCES_FOR_LESSON',
  SET_EXECUTOR_RESOURCES: 'SET_EXECUTOR_RESOURCES',
  GET_LESSON_DEFINITION: 'GET_LESSON_DEFINITION',
  SET_LESSON_DEFINITION: 'SET_LESSON_DEFINITION',
  WAIT_FOR_RESOURCES: 'WAIT_FOR_RESOURCES',
  SET_EXECUTOR_RESOURCES_FOR_LESSON: 'SET_EXECUTOR_RESOURCES_FOR_LESSON',
  RESOURCE_LOADED_FOR_LESSON: 'RESOURCE_LOADED_FOR_LESSON',
  RESOURCES_LOADING_FOR_LESSON_SUCCESS: 'RESOURCES_LOADING_FOR_LESSON_SUCCESS',
  RESOURCES_LOADING_FOR_LESSON_FAILED: 'RESOURCES_LOADING_FOR_LESSON_FAILED',
  SET_PLAYER_MODE: 'SET_PLAYER_MODE',
  SET_PLAYER_ROLE: 'SET_PLAYER_ROLE',
  SET_PROCESS_AS_RESOURCE: 'SET_PROCESS_AS_RESOURCE',
  SET_RESOURCES_FROM_API: 'SET_RESOURCES_FROM_API', // <-- new action type
  SET_OFFLINE_MODE: 'SET_OFFLINE_MODE',
};

export const getResourcesForLesson = (payload: any) => {
  return {
    type: types.GET_RESOURCES_FOR_LESSON,
    payload,
  };
};

export const setExecutorResources = (payload: any) => {
  return { type: types.SET_EXECUTOR_RESOURCES, payload };
};

export const getLessonDefinition = (payload: any) => {
  return {
    type: types.GET_LESSON_DEFINITION,
    payload,
  };
};

export const getFile = (
  payload: any,
  action: any,
  createPayload?: (value: any) => void
) => {
  return {
    type: types.GET_FILE,
    payload,
    action,
    createPayload,
  };
};

export const setProcessAsResource = (payload: any) => {
  return {
    type: types.SET_PROCESS_AS_RESOURCE,
    payload
  }
}

export const waitForResources = (payload: any) => {
  return {
    type: types.WAIT_FOR_RESOURCES,
    payload,
  };
};

export const setExecutorResourcesForLesson = (payload: any) => {
  return {
    type: types.SET_EXECUTOR_RESOURCES_FOR_LESSON,
    payload,
  };
};

export const resourceLoadedForLesson = (payload: any) => {
  return {
    type: types.RESOURCE_LOADED_FOR_LESSON,
    payload,
  };
};

export const resourceLoadingForLessonSuccess = (payload: string) => {
  return {
    type: types.RESOURCES_LOADING_FOR_LESSON_SUCCESS,
    payload,
  };
};

export const resourceLoadingForLessonFailed = (payload: string) => {
  return {
    type: types.RESOURCES_LOADING_FOR_LESSON_FAILED,
    payload,
  };
};

export const setPlayerRole = (payload: any) => {
  return {
    type: types.SET_PLAYER_ROLE,
    payload,
  };
};

export const setPlayerMode = (payload: any) => {
  return {
    type: types.SET_PLAYER_MODE,
    payload,
  };
};

export const setResourcesFromApi = (payload: any) => {
  return { type: types.SET_RESOURCES_FROM_API, payload };
};

export const setOfflineMode = (payload: boolean) => {
  return { type: types.SET_OFFLINE_MODE, payload };
};
